import { render, staticRenderFns } from "./fullView.vue?vue&type=template&id=02f1482a&scoped=true"
import script from "./fullView.vue?vue&type=script&lang=js"
export * from "./fullView.vue?vue&type=script&lang=js"
import style0 from "./fullView.vue?vue&type=style&index=0&id=02f1482a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f1482a",
  null
  
)

export default component.exports